import { onMounted, type Ref } from 'vue'
import { useScriptTag } from '@vueuse/core'

declare global {
  interface Window {
    Trustpilot?: { loadFromElement(el: HTMLElement | undefined): void }
  }
}

const TRUSTPILOT_SCRIPT = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'

export function useTrustpilot (el?: Ref<HTMLElement | undefined>) {
  if (window.Trustpilot) {
    if (el) onMounted(() => { window.Trustpilot?.loadFromElement(el.value) })
  }
  else {
    const { load } = useScriptTag(TRUSTPILOT_SCRIPT, undefined, { manual: true })
    onMounted(() => load().catch(() => {}))
  }
}
